(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("BalanceCard", [], factory);
	else if(typeof exports === 'object')
		exports["BalanceCard"] = factory();
	else
		root["BalanceCard"] = factory();
})(this, function() {
return 